<template>
  <div>
    <modal-ball-status ref="modalballstatus"></modal-ball-status>
    <Card :bordered="false" shadow>
      <Row type="flex" align="middle">
        <template v-if="this.getpermission.lottery[1] == '1'">
          <div class="mb-3" v-if="isPerHidden">
            <!-- <div> -->
            <Button
              type="error"
              class="mr-3"
              @click.stop.prevent="ptmark()"
              :disabled="ButtonSettlementDisabled"
            >结算</Button>
            <Button
              type="error"
              class="mr-3"
              @click.stop.prevent="resett()"
              :disabled="!ButtonSettlementDisabled"
            >重新结算</Button>
            <Button type="error" class="mr-3" @click.stop.prevent="zeroing()">反结算</Button>
          </div>
          <table class="TB_COLLAPSE" width="100%">
            <thead>
              <th width="12.5%">日期</th>
              <th width="12.5%">一号</th>
              <th width="12.5%">二号</th>
              <th width="12.5%">三号</th>
              <th width="12.5%">四号</th>
              <th width="12.5%">五号</th>
              <th width="12.5%">六号</th>
              <th width="12.5%">七号</th>
            </thead>
            <tbody>
              <tr class="tc">
                <td>
                  <Select style="width: 120px" v-model="selectState" @on-change="getselect">
                    <Option v-for="it in lotteryData.date" :key="it.id" :value="it.id">{{ it.date }}</Option>
                  </Select>
                </td>
                <td v-for="(i, index) in 7" :key="'input' + i">
                  <Input v-model="number[`cmn${i}`]" style="width: 120px" />
                </td>
              </tr>
              <tr class="tc" v-if="isPerHidden">
                <!-- <tr> -->
                <td colspan="10">
                  <Button type="error" @click="settle">
                    <b>设定号码</b>
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
          <divider />
        </template>
        <lida-table :propscolumns="columns" :data="table" :sortStatus="false">
          <template v-slot:headerSelect>
            <span>刷新开奖号码：</span>
            <Select
              v-model="secondsindex"
              style="width: 70px"
              @on-change="(index) => (seconds = secondsList[secondsindex])"
            >
              <Option v-for="(item, index) in secondsList" :value="index" :key="item">{{ item }}</Option>
            </Select>
            <span>刷新开奖号码： {{ seconds }} 秒</span>
          </template>
        </lida-table>
      </Row>
    </Card>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { KeyControlName, accNum } from "utils";
export default {
  name: 'open-management',
  inject: ["LoadingShow"],
  components: {
    ModalBallStatus: () => import(/* webpackChunkName: "ModalBallStatus" */ './components/ModalBallStatus'),
  },
  data () {
    return {
      table: [],
      lotteryData: {},
      seconds: 300,
      secondsindex: 0,
      secondsTime: null,
      ButtonSettlementDisabled: false,
      secondsList: [300, 120, 60, 30, 10],
      number: {
        cmn1: "",
        cmn2: "",
        cmn3: "",
        cmn4: "",
        cmn5: "",
        cmn6: "",
        cmn7: ""
      },
      columns: {
        date: {
          title: "开奖日期",
          key: "date",
          align: "center",
          width: 150,
        },
        cmn1: {
          title: "开奖结果",
          key: "cmn1",
          align: "center",
          className: "lottery-ball",
          width: 600,
          render: (h, params) => {
            const it = params.row;
            let ArrayTemplate = [];
            for (let i = 1; i <= 7; i++) {
              if (it[`cmn${i}`] != "00") {
                const _class = { "mr-1 ball": true };
                const _Template = h("span", [
                  h(
                    "span",
                    {
                      class: {
                        ..._class,
                        fontweight: true,
                        [`ball${it[`cmn${i}clr`]}`]: true
                      }
                    },
                    it[`cmn${i}`]
                  ),
                  h("span", { class: _class }, it[`cmn${i}yzo`])
                ]);
                ArrayTemplate.push(_Template);
              }
            }
            return ArrayTemplate;
          }
        },
        sum: {
          title: "总分",
          key: "sum",
          align: "center",
          render: (h, params) =>
            params.row.cmn7 != "00" ? h("p", params.row.sum) : null
        },
        pcmn7sd: {
          title: "特码单双",
          key: "cmn7sd",
          align: "center",
          render: (h, params) =>
            params.row.cmn7 != "00"
              ? h("p", KeyControlName.SingleAnddouble("特")[params.row.cmn7sd])
              : null
        },
        cmn7bs: {
          title: "特码大小",
          key: "cmn7bs",
          align: "center",
          render: (h, params) =>
            params.row.cmn7 != "00"
              ? h(
                "p",
                KeyControlName.SixmarkSmallAndBig("特")[params.row.cmn7bs]
              )
              : null
        },
        cmn7psd: {
          title: "特码合数单双",
          key: "cmn7psd",
          align: "center",
          render: (h, params) =>
            params.row.cmn7 != "00"
              ? h("p", KeyControlName.SingleAnddouble("合")[params.row.cmn7psd])
              : null
        },
        tnsd: {
          title: "总数单双",
          key: "tnsd",
          align: "center",
          render: (h, params) => {
            if (params.row.cmn7 == "00") return
            const tnbsDom =
              params.row.tnyzo == "0"
                ? this.NotYetSettle(h)
                : h("p", KeyControlName.SingleAnddouble("总")[params.row.tnsd])
            return tnbsDom
          }
        },
        tnbs: {
          title: "总数大小",
          key: "tnbs",
          align: "center",
          render: (h, params) => {
            if (params.row.cmn7 == "00") return

            const tnbsDom =
              params.row.tnyzo == "0"
                ? this.NotYetSettle(h)
                : h("p", KeyControlName.SixmarkSmallAndBig("总")[params.row.tnbs])
            return tnbsDom
          }
        },
        tnyzo: {
          title: "生肖总量",
          key: "tnyzo",
          align: "center",
          width: 200,
          render: (h, params) => {
            if (params.row.cmn7 == "00") return

            const tnyzoDom =
              params.row.tnyzo == "0"
                ? this.NotYetSettle(h)
                : h("p", params.row.tnyzo);
            return h("span", [tnyzoDom, h("p", params.row.yzoslist)]);
          }
        }
      },
      selectState: null
    };
  },
  computed: {
    ...mapGetters(["getmember", "getpermission", "getgameid"]),
    isPerHidden () {
      let sate = this.lotteryData.isperhidden == 0 ? true : false
      if (this.lotteryData.date) {
        sate = this.selectState == this.lotteryData.date[0].id ? true : false
      }
      return sate
    },
  },
  watch: {
    getgameid () {
      clearInterval(this.secondsTime)
      this.gettb();
      this.getselect();
      this.tableSetInterval()
    },
    seconds (val) {
      if (val === 0) {
        this.gettb()
        // this.seconds = this.secondsList[this.secondsindex]
      }
    }
  },
  created () {
    this.gettb();
    this.getselect();
    this.tableSetInterval()
  },
  beforeDestory () {
    clearInterval(this.secondsTime)
    this.secondsTime = null
  },
  methods: {
    async gettb () {
      this.seconds = this.secondsList[this.secondsindex]
      try {
        const result = await this.$axios.openManagement.table(this.getgameid)
        if ('status' in result && result.status === 0) return
        this.table = result
      } catch (error) {
        this.$Notice.error("网路异常:(S6001)");
      }
    },
    async getselect (pid) {
      try {
        const res = await this.$axios.openManagement.select(this.getgameid, pid)
        if ('status' in res && res.status === 0) return
        const it = res[0];
        this.lotteryData = it;
        this.ButtonSettlementDisabled = [1, 3].some(res => res == it.isclea)
        if (!it.date) {
          this.$Message.error('无期数资讯')
          this.selectState = []
          for (let i = 1; i <= 7; i++) {
            const key = `cmn${i}`;
            this.number[key] = ''
            this.lotteryData[key] = ''
          }
          return
        }
        if (!pid) this.selectState = it.date[0].id;
        for (let i = 1; i <= 7; i++) {
          const key = `cmn${i}`;
          this.number[key] = it[key] != "0" ? it[key] : "";
          this.lotteryData[key] = it[key] != "0" ? it[key] : "";
        }
      } catch (error) {
        this.$Message.error("网路异常:(S6002)");
      }
    },
    //设定号码
    async settle () {
      try {

        let check = true;
        let notIterate = true;
        const oldcmn = Array.from(
          { length: 7 },
          (v, i) => this.lotteryData[`cmn${i + 1}`]
        );
        const cmn = Object.values(this.number);
        const cmnClean = cmn.filter(it => it != "").sort();
        const items = [];

        if (cmn.some(it => it >= 50)) {
          this.$Message.error("号码大于49");
          check = false;
          return;
        }

        if (cmn.some(it => {
          if (String(it).length > 0) {
            if (!accNum.accPlusInt(it) || it < 1) return true
          } else {
            return false
          }
        })) {
          this.$Message.error("请输入正确号码");
          check = false;
          return;
        }

        for (let i = 0; i < cmnClean.length; i++) {
          if (cmnClean[i] == cmnClean[i + 1]) {
            notIterate = false;
            this.$Message.error(`号码已重复`);
            break;
          }
        }

        if (notIterate) {
          for (let i = 0; i <= 6; i++) {
            if (oldcmn[i] != cmn[i]) {
              if (oldcmn[i] == "") {
                const obj = { cmn: i + 1, cmn17: cmn[i] };
                items.push(obj);
                check = true;
              } else {
                check = false;
                this.$Notice.open({
                  title: `号码${i + 1}已结算，若要修改请按重新结算`
                });
                break;
              }
            }
          }
          if (check) {
            this.LoadingShow(true);
            this.ButtonSettlementDisabled = true
            const ay = {};
            ay["loid"] = this.getmember.pid;
            ay["pid"] = this.lotteryData.pid;
            ay["items"] = items;
            const res = await this.$axios.openManagement.settingLotteryBall(this.getgameid, ay)
            if (res.status == 1) {
              this.gettb();
              this.getselect(this.lotteryData.pid);
            }
            this.$refs.modalballstatus.settingBall(true, res, '1')
            setTimeout(() => {
              this.ButtonSettlementDisabled = false
            }, 2000);
          }
        }
      } catch (error) {
        setTimeout(() => {
          this.ButtonSettlementDisabled = false
        }, 2000);
        this.$Notice.error("网路异常:(S6003)");
      } finally {
        this.LoadingShow(false);
      }
    },
    // 已结算
    ptmark () {
      const checkball = () => {
        for (let i = 1; i <= 7; i++) {
          if (this.lotteryData[`cmn${i}`] == "") {
            this.$Message.error("请先完成七颗球设定");
            return false;
          }
        }
        return true;
      };
      if (checkball()) {

        this.LoadingShow(true);
        const data = { pid: this.lotteryData.pid, loid: this.getmember.pid };
        this.$axios.openManagement
          .settlement(this.getgameid, data)
          .then(async res => {
            if (res.status == "1") {
              this.gettb();
              this.getselect(this.lotteryData.pid);
              this.$Message.success("已结算");
            }
            this.$refs.modalballstatus.settingBall(true, res, '2')
            await this.LoadingShow(false);
          })
          .catch(err => {
            this.LoadingShow(false);
            alert("error");
          });
      } else {
        alert("请先完成七颗球设定");
      }
    },
    //重新结算
    resett () {
      let cmn1 = this.number.cmn1;
      let cmn2 = this.number.cmn2;
      let cmn3 = this.number.cmn3;
      let cmn4 = this.number.cmn4;
      let cmn5 = this.number.cmn5;
      let cmn6 = this.number.cmn6;
      let cmn7 = this.number.cmn7;

      if (cmn1 == "") {
        cmn1 = "0";
      }
      if (cmn2 == "") {
        cmn2 = "0";
      }
      if (cmn3 == "") {
        cmn3 = "0";
      }
      if (cmn4 == "") {
        cmn4 = "0";
      }
      if (cmn5 == "") {
        cmn5 = "0";
      }
      if (cmn6 == "") {
        cmn6 = "0";
      }
      if (cmn7 == "") {
        cmn7 = "0";
      }
      if (
        cmn1 > 49 ||
        cmn2 > 49 ||
        cmn3 > 49 ||
        cmn4 > 49 ||
        cmn5 > 49 ||
        cmn6 > 49 ||
        cmn7 > 49
      ) {
        alert("号码大于49");
      } else {
        this.LoadingShow(true);
        const data = {
          pid: Number(this.lotteryData.pid),
          loid: this.getmember.pid,
          cmn1: Number(cmn1),
          cmn2: Number(cmn2),
          cmn3: Number(cmn3),
          cmn4: Number(cmn4),
          cmn5: Number(cmn5),
          cmn6: Number(cmn6),
          cmn7: Number(cmn7)
        };
        this.$axios.openManagement
          .resetSettlement(this.getgameid, data)
          .then(res => {
            if (res.status == "1") {
              this.gettb();
              this.getselect(this.lotteryData.pid);
              this.$Message.success("已重新结算");
            }
            this.$refs.modalballstatus.settingBall(true, res, '3')
            this.LoadingShow(false);
          })
          .catch(err => {
            this.LoadingShow(false);
            alert("error");
          });
      }
    },
    //归零
    zeroing () {
      this.LoadingShow(true);
      const data = {
        pid: this.lotteryData.pid,
        loid: this.getmember.pid
      };
      this.$axios.openManagement
        .backSettlement(this.getgameid, data)
        .then(res => {
          if (res.status == "1") {
            this.gettb();
            this.getselect(this.lotteryData.pid);
          }
          this.$refs.modalballstatus.settingBall(true, res, '4')
          this.LoadingShow(false);
        })
        .catch(err => {
          this.LoadingShow(false);
          alert("error");
        });
    },
    NotYetSettle (h) {
      const _class = { 'red-text': true }
      return h("span", [h("p", "--"), h("p", { class: _class }, "请结算")])
    },
    tableSetInterval () {
      this.secondsTime = setInterval(() => (this.seconds -= 1), 1000);
    },
    ModalSettingBall () {

    }
  }
};
</script>
<style lang="scss">
.lottery-ball {
  .ivu-table-cell {
    padding: 4px 0;
  }
}
</style>